export enum WalletEventName {
  ExploreSearchCancel = 'Explore Search Cancel',
  NFTsLoaded = 'NFTs Loaded',
  NetworkFilterSelected = 'Network Filter Selected',
  PortfolioBalanceFreshnessLag = 'Portfolio Balance Freshness Lag',
  PerformanceGraphql = 'Performance GraphQL',
  SendRecipientSelected = 'Send Recipient Selected',
  ShareButtonClicked = 'Share Button Clicked',
  SwapSubmitted = 'Swap Submitted to Provider',
  TokenSelected = 'Token Selected',
  TransferCompleted = 'Transfer Completed',
  TransferSubmitted = 'Transfer Submitted',
}
